import * as Models from '../models';

/** ================================
*  DataStore共通処理
*  ================================*/

// UserTypeを変換する
export const convUserType = (userType: Models.UserType | keyof typeof Models.UserType) => {
  switch (userType) {
    case Models.UserType.PRODUCER:
      return '生産者';
    case Models.UserType.INSTRUCTOR:
      return '普及指導員';
    case Models.UserType.ADMINISTRATOR:
      return '管理者';
    default:
      return '';
  }
}

// isEnabledを変換する
export const convIsEnabled = (isEnabled?: boolean | null) => {
  return isEnabled ? '有効' : '無効';
}
